import { useEffect } from 'react';

export const useCloseClickOutside = (ref: React.RefObject<HTMLElement | null>, callback: () => void) => {
  useEffect(() => {
    const documentClickHandler = function (e: Event) {
      if (!e.composedPath().includes(ref.current as EventTarget)) {
        callback();
      }
    };

    document.addEventListener('click', documentClickHandler);

    return () => {
      document.removeEventListener('click', documentClickHandler);
    };
  }, [ref, callback]);
};
